import { createAction, props } from '@ngrx/store';

import { DeliverySort } from './delivery-sort.reducer';

const ACTION_KEY = '[Delivery Sort]';

export const setSort = createAction(
  `${ACTION_KEY} set sort`,
  (deliverySort: DeliverySort) => deliverySort,
);

export const setSortField = createAction(
  `${ACTION_KEY} Set sort field name`,
  props<{ fieldName: string }>(),
);

export const setSortType = createAction(
  `${ACTION_KEY} Set sort type`,
  props<{ sortType: 'asc' | 'desc' }>(),
);

export const resetSort = createAction(`${ACTION_KEY} Reset sort`);

export const setUnread = createAction(
  `${ACTION_KEY} set unread`,
  props<{ viewBy: 'All' | 'unread' }>(),
);
